import { QueryClient } from '@tanstack/react-query';

/**
 * One QueryClient for the app. Query keys are `[domain, callable, params]` (docs/07 §3.5).
 * The single sign-out service clears this cache (docs/05 single sign-out source).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
